


// import React, { useState, useEffect,useRef } from 'react';
// import { Formik, Form } from 'formik';
// import * as Yup from 'yup';
// import { Button } from '@mui/material';
// import { styled } from '@mui/material/styles';
// import ConsumerFormFields from './ConsumerFormFields';
// import ConfirmDialog from '../../../components/ConfirmDialog';
// import SuccessSnackbar from '../../../components/SuccessSnackbar';
// import FormContainerWrapper from '../../../components/FormContainerWrapper';
// import { useAuth } from '../../../AuthContext';

// // Validation schema
// const consumerSchema = Yup.object().shape({
//   name: Yup.string()
//     .min(2, 'Name must be at least 2 characters')
//     .max(50, 'Name must be less than 50 characters')
//     .required('Name is required'),
//   mobile_number: Yup.string()
//     .matches(/^\d{10}$/, 'Mobile Number must be exactly 10 digits')
//     .required('Mobile Number is required'),
//   farm_address: Yup.string()
//     .min(5, 'Farm Address must be at least 5 characters')
//     .required('Farm Address is required'),
//   service_number: Yup.string()
//     .min(3, 'Service Number must be at least 3 characters')
//     .required('Service Number is required'),
//   imei_list: Yup.array()
//     .min(1, 'At least one pump must be selected')
//     .required('Pumps selection is required'),
//   password: Yup.string()
//     .min(8, 'Password must be at least 8 characters')
//     .required('Login Password is required'),
// });

// // Styled button
// const SubmitButton = styled(Button)(({ theme }) => ({
//   marginTop: theme.spacing(4),
//   padding: theme.spacing(1.5),
//   borderRadius: '10px',
//   backgroundColor: '#1976d2',
//   fontWeight: 'bold',
//   fontSize: '1rem',
//   '&:hover': {
//     backgroundColor: '#1565c0',
//   },
// }));

// const ConsumerCreation = () => {
//   const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
//   const [openSnackbar, setOpenSnackbar] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState('');
//   const [snackbarSeverity, setSnackbarSeverity] = useState('success');
//   const [formValues, setFormValues] = useState(null);
//   const { createConsumer, pumpsWithImei } = useAuth();
//   const formikRef = useRef(null);

//   const handleSubmit = (values,{resetForm}) => {
//     values.username = values.mobile_number;
//     setFormValues(values);
//     setOpenConfirmDialog(true);
//     formikRef.current = resetForm;
//   };

//   const handleConfirm = async () => {
//     try {
//       if (!formValues) return;
      
//       await createConsumer(formValues);
      
//       // Clear form values before showing success
//       setFormValues(null);
//       setOpenConfirmDialog(false);
//       if (formikRef.current) {
//         console.log(formikRef.current.handleReset)
//         formikRef.current.handleReset()
//       }
//       // Set success message
//       setSnackbarMessage(`Consumer ${formValues.name} Created Successfully!`);
//       setSnackbarSeverity('success');
//       setOpenSnackbar(true);
      
//     } catch (error) {
//       setOpenConfirmDialog(false);
      
//       // Clear form values on error too
//       setFormValues(null);
      
//       // Check if the error is from the API response
//       let errorMsg = "Failed to create consumer. Please try again.";
//      //console.log('this is the error from consumer creation',error)
//       if (error.message.includes("Mobile number already exists")) {
//         errorMsg = "This mobile number is already registered. Please use a different number.";
//       } else if (error.response) {
//         try {
//           const errorData = await error.response.json();
//           errorMsg = errorData.error || errorMsg;
//         } catch (e) {
//           console.error("Error parsing error response:", e);
//         }
//       }
      
//       setSnackbarMessage(errorMsg);
//       setSnackbarSeverity('error');
//       setOpenSnackbar(true);
//     }
//   };

//   const handleCloseSnackbar = () => {
//     setOpenSnackbar(false);
//     // Don't clear message immediately to prevent flicker
//     setTimeout(() => {
//       setSnackbarMessage('');
//       setSnackbarSeverity('success');
//     }, 300);
//   };

//   return (
//     <FormContainerWrapper title="Add New Consumer">
//       <Formik
//         initialValues={{
//           name: '',
//           mobile_number: '',
//           farm_address: '',
//           service_number: '',
//           imei_list: [],
//           geolocation:[],
//           username: '',
//           password: '',
//         }}
//         validationSchema={consumerSchema}
//         onSubmit={handleSubmit}
//         innerRef={formikRef} // Connect the ref to Formik
//       >
//         {({ errors, touched, setFieldValue, values }) => (
//           <Form>
//             <ConsumerFormFields 
//               errors={errors} 
//               touched={touched} 
//               pumps={pumpsWithImei}
//               setFieldValue={setFieldValue}
//               values={values}
//             />
//             <SubmitButton type="submit" variant="contained" fullWidth>
//               Submit
//             </SubmitButton>
//           </Form>
//         )}
//       </Formik>

//       <ConfirmDialog
//         open={openConfirmDialog}
//         onClose={() => setOpenConfirmDialog(false)}
//         onConfirm={handleConfirm}
//         title="Confirm Consumer Details"
//         content={
//           formValues && (
//             <div className="space-y-2">
//               <p><strong>Name:</strong> {formValues.name}</p>
//               <p><strong>Mobile Number:</strong> {formValues.mobile_number}</p>
//               <p><strong>Farm Address:</strong> {formValues.farm_address}</p>
//               <p><strong>Service Number:</strong> {formValues.service_number}</p>
//               <p><strong>Pumps Owned:</strong> {formValues.imei_list?.join(', ') || 'None'}</p>
//               <p><strong>Login Username:</strong> {formValues.username}</p>
//             </div>
//           )
//         }
//       />

//       <SuccessSnackbar
//         open={openSnackbar}
//         onClose={handleCloseSnackbar}
//         message={snackbarMessage}
//         severity={snackbarSeverity}
//         autoHideDuration={snackbarSeverity === 'error' ? 6000 : 3000}
//       />
//     </FormContainerWrapper>
//   );
// };

// export default ConsumerCreation;









import React, { useState, useEffect, useRef } from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import ConsumerFormFields from './ConsumerFormFields';
import ConfirmDialog from '../../../components/ConfirmDialog';
import SuccessSnackbar from '../../../components/SuccessSnackbar';
import FormContainerWrapper from '../../../components/FormContainerWrapper';
import { useAuth } from '../../../AuthContext';

// Validation schema
const consumerSchema = Yup.object().shape({
  name: Yup.string()
    .min(2, 'Name must be at least 2 characters')
    .max(50, 'Name must be less than 50 characters')
    .required('Name is required'),
  mobile_number: Yup.string()
    .matches(/^\d{10}$/, 'Mobile Number must be exactly 10 digits')
    .required('Mobile Number is required'),
  farm_address: Yup.string()
    .min(5, 'Farm Address must be at least 5 characters')
    .required('Farm Address is required'),
  service_number: Yup.string()
    .min(3, 'Service Number must be at least 3 characters')
    .required('Service Number is required'),
  imei_list: Yup.array()
    .of(Yup.string())
    .min(1, 'Please select one pump')
    .max(1, 'Only one pump can be selected')
    .required('Pumps selection is required'),
     panel_number_list: Yup.array()
            .of(Yup.string())
            .min(1, 'Please enter atleast one Panel No')
            .required('Panel number is required'),
  password: Yup.string()
    .min(8, 'Password must be at least 8 characters')
    .required('Login Password is required'),
  geolocation: Yup.array()
    .of(Yup.number().nullable())
    .length(2, 'Geolocation must contain exactly two values (latitude, longitude)')
    .test('latitude', 'Latitude must be between -90 and 90', (value) =>
      value && value[0] !== null ? value[0] >= -90 && value[0] <= 90 : true
    )
    .test('longitude', 'Longitude must be between -180 and 180', (value) =>
      value && value[1] !== null ? value[1] >= -180 && value[1] <= 180 : true
    )
    .nullable(),
});

// Styled button
const SubmitButton = styled(Button)(({ theme }) => ({
  marginTop: theme.spacing(4),
  padding: theme.spacing(1.5),
  borderRadius: '10px',
  backgroundColor: '#1976d2',
  fontWeight: 'bold',
  fontSize: '1rem',
  '&:hover': {
    backgroundColor: '#1565c0',
  },
}));

const ConsumerCreation = () => {
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  const [formValues, setFormValues] = useState(null);
  const { createConsumer, pumpsWithImei } = useAuth();
  const formikRef = useRef(null);

  const handleSubmit = (values, { resetForm }) => {
    values.username = values.mobile_number;
    setFormValues(values);
    setOpenConfirmDialog(true);
    formikRef.current = { handleReset: resetForm };
  };

  const handleConfirm = async () => {
    try {
      if (!formValues) return;
      await createConsumer(formValues);
      setFormValues(null);
      setOpenConfirmDialog(false);
      if (formikRef.current) {
        formikRef.current.handleReset();
      }
      setSnackbarMessage(`Consumer ${formValues.name} Created Successfully!`);
      setSnackbarSeverity('success');
      setOpenSnackbar(true);
    } catch (error) {
      setOpenConfirmDialog(false);
      setFormValues(null);
      let errorMsg = 'Failed to create consumer. Please try again.';
      if (error.message.includes('Mobile number already exists')) {
        errorMsg = 'This mobile number is already registered. Please use a different number.';
      } else if (error.response) {
        try {
          const errorData = await error.response.json();
          errorMsg = errorData.error || errorMsg;
        } catch (e) {
          console.error('Error parsing error response:', e);
        }
      }
      setSnackbarMessage(errorMsg);
      setSnackbarSeverity('error');
      setOpenSnackbar(true);
    }
  };

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
    setTimeout(() => {
      setSnackbarMessage('');
      setSnackbarSeverity('success');
    }, 300);
  };

  return (
    <FormContainerWrapper title="Add New Consumer">
      <Formik
        initialValues={{
          name: '',
          mobile_number: '',
          farm_address: '',
          service_number: '',
          imei_list: [],
          geolocation: ['', ''], // Initialize as empty strings
           panel_number_list:'',
          username: '',
          password: '',
        }}
        validationSchema={consumerSchema}
        onSubmit={handleSubmit}
        innerRef={formikRef}
      >
        {({ errors, touched, setFieldValue, values }) => (
          <Form>
            <ConsumerFormFields 
              errors={errors} 
              touched={touched} 
              pumps={pumpsWithImei}
              setFieldValue={setFieldValue}
              values={values}
            />
            <SubmitButton type="submit" variant="contained" fullWidth>
              Submit
            </SubmitButton>
          </Form>
        )}
      </Formik>

      <ConfirmDialog
        open={openConfirmDialog}
        onClose={() => setOpenConfirmDialog(false)}
        onConfirm={handleConfirm}
        title="Confirm Consumer Details"
        content={
          formValues && (
            <div className="space-y-2">
              <p><strong>Name:</strong> {formValues.name}</p>
              <p><strong>Mobile Number:</strong> {formValues.mobile_number}</p>
              <p><strong>Farm Address:</strong> {formValues.farm_address}</p>
              <p><strong>Service Number:</strong> {formValues.service_number}</p>
              <p><strong>Pump:</strong> {formValues.imei_list?.join(', ') || 'None'}</p>
              <p><strong>Geolocation:</strong> {formValues.geolocation?.[0] && formValues.geolocation?.[1] ? `[${formValues.geolocation[0]}, ${formValues.geolocation[1]}]` : 'Not provided'}</p>
                <p><strong>Panel No:</strong> {formValues.panel_number_list?.join(', ') || 'None'}</p>
              <p><strong>Login Username:</strong> {formValues.username}</p>
            </div>
          )
        }
      />

      <SuccessSnackbar
        open={openSnackbar}
        onClose={handleCloseSnackbar}
        message={snackbarMessage}
        severity={snackbarSeverity}
        autoHideDuration={snackbarSeverity === 'error' ? 6000 : 3000}
      />
    </FormContainerWrapper>
  );
};

export default ConsumerCreation;